import { Button, DialogFooter } from '@fortem-monorepo/react-ui'

import { AccruedInterestDialogFrame } from './AccruedInterestDialogFrame'

export type DiscardDraftsDialogProps = { description: string; onDiscard: () => void; onClose: () => void }

export const DiscardDraftsDialog = ({ description, onDiscard, onClose }: DiscardDraftsDialogProps) => (
  <AccruedInterestDialogFrame title="Discard pending corrections?" description={description} onClose={onClose}>
    <p className="text-sm">Pending balance corrections have not been saved. Continuing will discard them.</p>
    <DialogFooter>
      <Button type="button" size="sm" variant="outline" onClick={onClose}>
        Keep corrections
      </Button>
      <Button
        type="button"
        size="sm"
        variant="destructive"
        onClick={() => {
          onDiscard()
          onClose()
        }}
      >
        Discard and continue
      </Button>
    </DialogFooter>
  </AccruedInterestDialogFrame>
)
